/** Ciro, maliyet ve kar yan yana gorunen yerlerin notu: elle cikarma kari vermez (990056: ciro `dahil_tutar`, kar `tutar`). */
export const KDV_KAR_NOTU = 'Ciro KDV dahildir, kâr KDV hariç tutardan hesaplanır; bu yüzden ciro eksi maliyet kâra eşit çıkmaz.';

/**
 * Ekranin kisa bicimleri. `fmtPct` (primitives) DEGISIM bicimidir ve pozitife '+' ekler; seviye oranlari
 * (marj, iade orani) icin kullanilmaz. Turkce'de yuzde isareti ONDE: %26,46; eksi isareti U+2212.
 */
export function kisaTutar(n: number): string {
  const a = Math.abs(n);
  // 999.500 ve ustu "Mn": 999.638,59 "1000 B" degil "1,00 Mn" okunmali (spec §3 ornegi).
  // Mn ve B dallari esik geregi sifira yuvarlanamaz; isaret yalniz alt dalda yuvarlamadan SONRA karar verir
  // (puanMetni kalibi): −0,4 "−₺0" degil "₺0".
  if (a >= 999_500) return `${n < 0 ? '−' : ''}₺${(a / 1e6).toFixed(2).replace('.', ',')} Mn`;
  if (a >= 999.5) return `${n < 0 ? '−' : ''}₺${Math.round(a / 1e3)} B`;
  const yuv = Math.round(a);
  return `${n < 0 && yuv !== 0 ? '−' : ''}₺${yuv}`;
}

/**
 * CONTROLLER RULING C-4: `kisaTutar` gibi ama ₺ isareti YOK. Kopru notunda (spec §3) yalniz iki ana
 * tutar ("Ürün satışı", "ürün dışı") ₺ tasir; alt kalemler ("Yemek kartı 1,00 Mn") tasimaz. Mantigi
 * TEKRARLAMAK yerine `kisaTutar`i cagirip sembolu siyoruz.
 */
export function kisaTutarIsaretsiz(n: number): string {
  return kisaTutar(n).replace('₺', '');
}

/** Isaret YUVARLAMADAN SONRA (puanMetni kalibi): −0,004 "−%0,00" degil "%0,00". */
export function oranMetni(n: number, hane = 2): string {
  const govde = Math.abs(n).toFixed(hane);
  const isaret = n < 0 && Number(govde) !== 0 ? '−' : '';
  return `${isaret}%${govde.replace('.', ',')}`;
}

export function puanMetni(n: number): string {
  const yuv = Math.round(n * 100) / 100;
  const isaret = yuv > 0 ? '+' : yuv < 0 ? '−' : '';
  return `${isaret}${Math.abs(yuv).toFixed(2).replace('.', ',')} puan`;
}

const MIKTAR = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 });

/**
 * S295 (kullanici 2026-09-23): miktar (kg, adet, gun) en cok 2 ondalik, gereksiz sifir yok: 18,75 · 3,5 · 12.
 * `fmtNum` (primitives) yuvarlamaz ve BUTUN firmalarin rapor tablolarinda kullanilir; ona dokunulmadi.
 * Isaret yuvarlamadan SONRA (puanMetni kalibi): −0,004 "−0" degil "0".
 */
export function miktarMetni(n: number): string {
  // Mutlak deger uzerinden: Math.round yarimi +sonsuza yuvarlar (−7,125 -> −7,12 olurdu).
  const yuv = Math.round(Math.abs(n) * 100) / 100;
  if (yuv === 0) return '0';
  return `${n < 0 ? '−' : ''}${MIKTAR.format(yuv)}`;
}
